var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { classnames, bem, use } from '../../lib';
import { TablContext } from './TablContext';
import Skeleton from 'react-skeleton-loader';
import { Icon } from '../../elements';
import { FlexBox } from '../FlexBox';
function renderSkeleton(inCheckbox = false) {
    return (React.createElement(Skeleton, { widthRandomness: 0, width: inCheckbox ? '1rem' : '100%', heightRandomness: 0, height: "100%" }));
}
export const TablCell = (_a) => {
    var { children, className, link, checkbox, skeleton, visibleOnHover, sortDirection, onSortDirectionChange } = _a, rest = __rest(_a, ["children", "className", "link", "checkbox", "skeleton", "visibleOnHover", "sortDirection", "onSortDirectionChange"]);
    const ctx = useContext(TablContext);
    const inHead = ctx.variant === 'head';
    let child = null;
    if (skeleton) {
        child = renderSkeleton(checkbox);
    }
    else {
        const handleSortChange = () => {
            if (!onSortDirectionChange)
                return;
            switch (sortDirection) {
                case 'ASC':
                    onSortDirectionChange('DESC');
                    break;
                case 'DESC':
                    onSortDirectionChange('ASC');
                    break;
                default:
                    onSortDirectionChange('DESC');
                    break;
            }
        };
        child = (React.createElement(FlexBox, { alignItems: "center", className: onSortDirectionChange ? 'tabl__cell-sort-container' : undefined, onClick: onSortDirectionChange ? handleSortChange : undefined },
            children,
            sortDirection && (React.createElement(Icon, { name: sortDirection === 'ASC' ? 'arrowUp' : 'arrowDown', className: "tabl__cell-sort-icon" }))));
    }
    const props = Object.assign(Object.assign({}, rest), { children: child, className: classnames(bem('tabl__cell', inHead ? '--head' : '--body', use(link, '--link'), use(checkbox, '--checkbox'), use(visibleOnHover, '--visible-on-hover')), className) });
    if (inHead) {
        return React.createElement("th", Object.assign({}, props, { scope: "col" }));
    }
    else {
        return React.createElement("td", Object.assign({}, props));
    }
};
//# sourceMappingURL=TablCell.js.map